import { Paper as MuiPaper, Link, Box, Divider, Tooltip } from "@mui/material";
import Typography from "component/MarketPlace/Typography";
import { TruncatedText } from "component/MarketPlace/Typography/Typography.style";
import React, { ReactNode, useContext } from "react";
import { ThemeContext } from "styled-components";
import { StyledContainer } from "./index.style";
import { handleKeyPress } from "utils/functions";
import parse from "html-react-parser";
import { useHyperlinkStyle } from "component/layoutComponents/CustomLayout/CustomLayoutContext";

export interface IGlobalSearchCard {
  title: ReactNode;
  description?: ReactNode;
  onClickViewDetail?: () => void;
  breadcrumbs: string;
  children?: ReactNode;
  standalone?: boolean;
  locale?: Record<string, any>;
  titleText?: string;
  paperProps?: any;
}

const GlobalSearchCard = (props: IGlobalSearchCard) => {
  const {
    title,
    description,
    onClickViewDetail,
    breadcrumbs,
    children,
    standalone = false,
    titleText = '',
    locale,
    paperProps = {},
  } = props;
  const theme = useContext(ThemeContext);
  const NUMBER_OF_CHARACTERS_SHOW_TOOLTIP = 55;

  const { hyperlinkStyle } = useHyperlinkStyle();

  return (
    <StyledContainer width="100%">
      <MuiPaper
        elevation={0}
        sx={{
          cursor: 'pointer',
          textDecoration: 'none',
          width: '100%',
          padding: standalone ? `${theme.uptimeSpace[8]}px ${theme.uptimeSpace[0]}px` : `${theme.uptimeSpace[8]}px`,
        }}
        onClick={onClickViewDetail}
        tabIndex={0} onKeyDown={(e: any) => handleKeyPress(e, 'Enter', onClickViewDetail)}
        id="crd-globalsearchcard-paper"
        {...paperProps}
      >
        <Box
          display="flex"
          alignItems={{ xs: 'flex-end', sm: 'center' }}
          justifyContent="space-between"
          flexDirection={{ xs: 'column', sm: 'row' }}
        >
          <Tooltip
            title={titleText?.length > NUMBER_OF_CHARACTERS_SHOW_TOOLTIP ? titleText : ''}
            arrow
            placement="bottom-start"
            PopperProps={{ sx: { '.MuiTooltip-tooltip': { maxWidth: 'none' } } }}
          >
            <Box maxWidth={{ sm: '400px', md: '700px' }} width="100%">
              <Typography
                whiteSpace="nowrap"
                textOverflow="ellipsis"
                overflow="hidden"
                variant="h4"
                color="text.primary"
              >
                {title}
              </Typography>
            </Box>
          </Tooltip>
          <Box>
            <Link
              // onClick={onClickViewDetail}
              sx={{ cursor: "pointer", textDecoration: "none", ...hyperlinkStyle }}
              role="link"
              tabIndex={0}
              aria-label="View Details"
            >
              <Typography variant="body2" color="primary.main" sx={{ ...hyperlinkStyle }} fontWeight={600}>
                {locale?.viewDetails}
              </Typography>
            </Link>
          </Box>
        </Box>
        <Box>
          <Typography variant="overline" color="primary.main" textTransform="capitalize">
            {breadcrumbs}
          </Typography>
        </Box>
        {description && (
          <Box sx={{'& strong': { backgroundColor: theme.uptimeColors.newsKnowledgeColors.highlight[0]}}}>
            <TruncatedText maxlines={3} variant="body2" color="text.secondary" sx={{fontSize: {xs: `${theme.uptimeFontSizes.mobile.fz2}px`, md: `${theme.uptimeFontSizes.desktop.fz4}px`}}}>
              {parse(description)}
            </TruncatedText>
          </Box>
        )}

        <Box>{children}</Box>
      </MuiPaper>
      <Divider />
    </StyledContainer>
  );
};

export default GlobalSearchCard;
